
import React from "react";
import { Snackbar, Box, Alert } from "@mui/material";

const GlassSnackbar = ({ open, onClose, message, severity = "success" }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionProps={{ onExited: () => onClose() }}
      sx={{
        mt: 0,
        zIndex: 1500,
        background: "transparent",
        backdropFilter: "blur(8px)",
      }}
    >
        <Alert
                  severity={severity}
                  variant="filled"
                  onClose={onClose}
                  sx={{
                    backgroundColor: "rgba(0, 123, 255, 0.1)",
                    color: "#0d47a1",
                    backdropFilter: "blur(5px)",
                    borderRadius: 3,
                    border: "1px solid #90caf9",
                    fontWeight: 500,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  }}
                >
                  {message}
                </Alert>
      {/* <Box
        sx={{
          px: 3,
          py: 1.5,
          borderRadius: "16px",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(12px)",
          color: severity === "error" ? "#f44336" : "#08AA66",
          fontWeight: 600,
          fontSize: "1rem",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          textAlign: "center",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        }}
      >
        {message}
      </Box> */}
    </Snackbar>
  );
};

export default GlassSnackbar;
